import { IProductPrices } from "../types/applicationContextTypes";
import {
  IMembershipLevel,
  ITotalCost,
} from "../../redux/WizardReducer/WizardReducer.types";
import { MembershipLevelsEnum } from "../enums/membershipLevelsEnum";

const getPrePaymentAmount = (
  productPrices: IProductPrices,
  totalCost: ITotalCost,
  membershipLevel: IMembershipLevel,
  isUpgrade: boolean
) => {
  let company =
    productPrices.companyPrePay.mdrtAmount > totalCost.membershipLevelCost
      ? totalCost.membershipLevelCost
      : productPrices.companyPrePay.mdrtAmount;
  let individual =
    productPrices.individualPrePay.mdrtAmount > totalCost.membershipLevelCost
      ? totalCost.membershipLevelCost
      : productPrices.individualPrePay.mdrtAmount;

  if (isUpgrade) {
    company = 0;
    individual = 0;
  }

  if (membershipLevel.selectedMembershipLevel === MembershipLevelsEnum.COT) {
    company += productPrices.companyPrePay.courtOfTableCovered
      ? productPrices.additionalFees.courtOfTable
      : 0;
    individual += productPrices.individualPrePay.courtOfTableCovered
      ? productPrices.additionalFees.courtOfTable
      : 0;
  } else if (
    membershipLevel.selectedMembershipLevel === MembershipLevelsEnum.TOT
  ) {
    if (productPrices.companyPrePay.courtOfTableCovered)
      company += productPrices.companyPrePay.topOfTableCovered
        ? productPrices.additionalFees.courtAndTopOfTable +
          productPrices.additionalFees.courtOfTable
        : productPrices.additionalFees.courtOfTable;
    if (productPrices.individualPrePay.courtOfTableCovered)
      individual += productPrices.individualPrePay.topOfTableCovered
        ? productPrices.additionalFees.courtAndTopOfTable +
          productPrices.additionalFees.courtOfTable
        : productPrices.additionalFees.courtOfTable;
  }

  return { company, individual };
};

export default getPrePaymentAmount;
